var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CenterDataContainer"},[_c('ContentTop',{attrs:{"title":"相关数据排行","topRadioProps":_vm.activeRankTopRadioProps,"type":3}}),_c('div',{staticClass:"rank-list",staticStyle:{"margin-top":"21px"}},[_c('rank-list',{attrs:{"view-type":"other","listHeight":345}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }